export const CHECK_PROFESSIONAL_KEY = "check-professional-data";
export const BUSINESS_CORES_KEY = "business-cores";
export const SESSION_TYPES_BY_CORE_KEY = "session-types-by-core";
export const PROFESSIONS_KEY = "professions";
export const REGISTRATION_TYPES_KEY = "registration-types";
export const ATTACHMENT_TYPES_KEY = "attachment-types";
export const VERSIONS_KEY = "versions";
export const AI_CARE_SUMMARY_KEY = "ai-care-summary";
export const AUDIT_SEARCH_KEY = "audit-search";
export const DATA_ANALYSIS_DASHBOARD_KEY = "data-analysis-dashboard";
export const AIRPORTS_KPI_KEY = "airports-kpi";
export const CLINIC_HISTORY_FORM_TYPES_KEY = "form-types";
export const SNOMED_SEARCH_KEY = "snomed-search";
export const AIRPORT_MEDICATIONS_KEY = "airport-medications";

// Airport catalogs
export const AIRPORT_CATALOG_AIRPORTS_KEY = "airport-catalog-airports";
export const AIRPORT_CATALOG_AIRLINES_KEY = "airport-catalog-airlines";
export const AIRPORT_CATALOG_PATIENT_TYPES_KEY =
  "airport-catalog-patient-types";
export const AIRPORT_CATALOG_CARE_LOCATIONS_KEY =
  "airport-catalog-care-locations";
export const MEDICAL_RECORD_SIGNATURE_IMAGE_URL_KEY = "medical-record-signature-image-url";

// Attention consent
export const SIGNATURE_PERSONS_KEY = "signature-persons";